import { memo, useEffect } from "react";
import { Navigate, Outlet, useNavigate } from "react-router-dom";

import { useStoreMe } from "@/hooks/useStoreMe";
import { useNotificationSocket } from "@/hooks/useNotificationSocket";
import { queryClient } from "@/lib/queryClient";
import { pinSession } from "@/utils/pinSession";

// bundle-barrel-imports: Direct imports instead of barrel

export const ProtectedStaffRoute = memo(() => {
  const navigate = useNavigate();
  const { isLoading, isError, data } = useStoreMe();

  // Listen for auth:logout events (dispatched by axios interceptor when refresh fails)
  useEffect(() => {
    const handleLogout = () => {
      queryClient.clear();
      pinSession.clear();
      navigate("/login", { replace: true });
    };

    window.addEventListener("auth:logout", handleLogout);
    return () => window.removeEventListener("auth:logout", handleLogout);
  }, [navigate]);

  // Connect to notification socket
  useNotificationSocket({ isStaff: true, enabled: true });

  // Loading: đang gọi GET /auth/store/me (hoặc đang refresh)
  if (isLoading) {
    return (
      <div className="flex h-screen w-full items-center justify-center bg-white">
        <div className="h-8 w-8 animate-spin rounded-full border-4 border-surfacePrimaryMedEm border-t-transparent"></div>
      </div>
    );
  }

  // Error hoặc không có data → redirect login
  if (isError || !data) {
    return <Navigate to="/login" replace />;
  }

  return <Outlet />;
});

ProtectedStaffRoute.displayName = "ProtectedStaffRoute";
